// extracted by mini-css-extract-plugin
export default {"tooltip":"OfferStatusLabel_tooltip__NJtyT"};